import { render, staticRenderFns } from "./shippingAddress.vue?vue&type=template&id=17893748&scoped=true&"
import script from "./shippingAddress.vue?vue&type=script&lang=js&"
export * from "./shippingAddress.vue?vue&type=script&lang=js&"
import style0 from "./shippingAddress.vue?vue&type=style&index=0&id=17893748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17893748",
  null
  
)

export default component.exports